<script setup lang="ts">
import { DrawerComponent, FlexComponent, LoadingComponent, useMobileView } from '@metapic-apps/shared'
import { useRoute, useRouter } from 'vue-router'

import { useGetCampaign } from '@/api/campaign.api'
import CampaignOverviewContent from '@/components/CampaignOverview/CampaignOverviewContent.vue'
import { useUserStore } from '@/stores/user.stores'

const props = withDefaults(defineProps<{ campaignId: number; editable?: boolean }>(), { editable: true })
const emit = defineEmits<{ delete: [campaignId: number] }>()

const isOpen = defineModel<boolean>('modelValue', { default: false })
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const { isMobileView } = useMobileView()
const { data: campaign, isLoading } = useGetCampaign(props.campaignId, {
  includes: () => (userStore.isAdmin ? ['additional_payment.cost_creator'] : []),
})

const handleClose = async () => {
  await router.push({ query: { ...route.query, campaignId: undefined } })
  isOpen.value = false
}

const handleDelete = async () => {
  emit('delete', props.campaignId)
  await handleClose()
}
</script>
<template>
  <DrawerComponent v-if="isOpen" v-model="isOpen" :size="isMobileView ? '100%' : '45%'" :resizable="!isMobileView" @closed="handleClose">
    <FlexComponent v-if="isLoading" justify="center" class="campaign-overview__loading">
      <LoadingComponent :size="48" />
    </FlexComponent>
    <CampaignOverviewContent v-else-if="campaign" :campaign="campaign" :editable="editable" @delete="handleDelete" />
  </DrawerComponent>
</template>
<style lang="scss" scoped>
.campaign-overview__loading {
  padding: 48px 0;
}
</style>
